import axios, { AxiosInstance, AxiosResponse } from "axios";
import {
  DEFAULT_COMMUNITY_ACCOUNT_ID,
  DEFAULT_LANGUAGE,
  SIGNUP_COMMUNITY_ACCOUNT_ID_SESSION_KEY,
  SIGNUP_LANGUAGE_SESSION_KEY
} from "features/common";
import { getSessionStorageValue } from "commons/utils";

export const APP_DEFAULT_HEADERS = {
  "content-type": "application/json",
  accepts: "application/json"
};
export interface ICreateHttpClient {
  baseUrl: string;
  headers?: Common.IDictionary<string>;
}

export function createHttpClient({ baseUrl, headers }: ICreateHttpClient): AxiosInstance {
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: { ...APP_DEFAULT_HEADERS, ...headers }
  });

  axiosInstance.interceptors.request.use(config => {
    const currentLanguage =
      getSessionStorageValue(SIGNUP_LANGUAGE_SESSION_KEY) || DEFAULT_LANGUAGE.code;

    const currentCommunity =
      getSessionStorageValue(SIGNUP_COMMUNITY_ACCOUNT_ID_SESSION_KEY) ||
      DEFAULT_COMMUNITY_ACCOUNT_ID;
      
    if (config.headers) {
      config.headers["Accept-Language"] = currentLanguage;
      config.headers["X-CommunityAccountId"] = currentCommunity;
    }

    return config;
  });

  axiosInstance.interceptors.response.use(
    response => response,
    (err: Error & { response: AxiosResponse }) => {
      if (!err.response || !err.response.request) {
        return Promise.reject(err);
      }

      return Promise.reject(err);
    }
  );

  return axiosInstance;
}
